import { SearchableText } from "../../../../../shared/components/search/Searchable"
import { getHostOrganizerName } from "../../home/components/meetigs/helpers"

import type { MeetingRoomBooking, MeetingRoomRow } from "../meetingRoomsTypes"
import { MeetingRoomBookingParticipants } from "./MeetingRoomBookingParticipants"

type MeetingRoomBookingMetaProps = Readonly<{
    booking: MeetingRoomBooking
    room: MeetingRoomRow
    searchRegex?: RegExp
}>

export function MeetingRoomBookingMeta({ booking, room, searchRegex }: MeetingRoomBookingMetaProps) {
    const ownerName = getHostOrganizerName([...booking.organizers])

    return (
        <>
            <SearchableText search={searchRegex}>{ownerName}</SearchableText>
            {booking.participants !== undefined && (
                <>
                    {ownerName && " · "}
                    <MeetingRoomBookingParticipants participants={booking.participants} seats={room.seats} />
                </>
            )}
        </>
    )
}
